/**
 * Utility functions for applying NewRelic masking classes based on configuration
 */

/**
 * Gets the masking class for sensitive fields based on NewRelic configuration
 * @param templateConfig - The template configuration object
 * @returns 'nr-mask' if masking should be applied, empty string otherwise
 */
export const getMaskClass = (templateConfig: any): string => {
  const unmaskSensitiveFields = templateConfig?.pages?.features?.newRelic?.unmaskSensitiveFields ?? false;
  return unmaskSensitiveFields ? '' : 'nr-mask';
};

/**
 * Gets the masking class for sensitive sections based on NewRelic configuration
 * @param templateConfig - The template configuration object
 * @returns 'nr-block' if masking should be applied, empty string otherwise
 */
export const getBlockClass = (templateConfig: any): string => {
  const unmaskSensitiveFields = templateConfig?.pages?.features?.newRelic?.unmaskSensitiveFields ?? false;
  return unmaskSensitiveFields ? '' : 'nr-block';
};
